// removed by extract-text-webpack-plugin
module.exports = {"NormalText":"editText__NormalText__33bji","Common":"editText__Common__11UDA","Title":"editText__Title__28gG2","Date":"editText__Date__1MF9V","Text":"editText__Text__3arEl","Radios":"editText__Radios__ctIRm","RadioItem":"editText__RadioItem__NIvUF","TextArea":"editText__TextArea__9yu34"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/EditableText/editText.css
// module id = 917
// module chunks = 2